import { IRestModel, RestApi } from "@nkr/utils/rest-api";

export interface IQualityTestVariable extends IRestModel {
    id          : string;
    testValue   : string;
}

export const useQualityTestVariableApi = () => {
    return new RestApi<IQualityTestVariable, IQualityTestVariable>(`${__API__}/qa/quality-test-variable`)
        .makeHooks();
}